import {useHistory} from 'react-router-dom';
import {MenuItem} from '@material-ui/core';
import React from 'react';
import {CreditActionType} from './CreditActionHelper';
import {useTranslation} from 'react-i18next';

const CreditDetailsAction = React.forwardRef<HTMLLIElement, CreditActionType>(({ credit, setMenuAnchor }, ref) => {
  const { t } = useTranslation('credits');

  let history = useHistory();
  return (
    <MenuItem
      ref={ref}
      onClick={() => {
        setMenuAnchor(null);
        history.push(`/dashboard/transactions/credits/${credit.id}/`);
      }}
    >
      {t('credit details')}
    </MenuItem>
  );
});

export default CreditDetailsAction;
